import { FUTUREFAIR_2026_DATA } from './futurefair-2026';

export const FUTURE_FAIR_ID = 'future-fair-2026';

function normalizeBoothKey(value) {
  return value.replace(/\s+/g, '').toUpperCase();
}

function splitArtists(artistsRaw) {
  const value = artistsRaw.trim();
  if (!value) return [];

  const commaOrSemicolonSplit = value
    .split(/[;,]/)
    .map(part => part.trim())
    .filter(Boolean);

  if (commaOrSemicolonSplit.length > 1) {
    return commaOrSemicolonSplit;
  }

  const andSplit = value
    .split(/\s+and\s+/i)
    .map(part => part.trim())
    .filter(Boolean);

  return andSplit.length > 1 ? andSplit : [value];
}

function toImageList(imagesLink) {
  if (imagesLink && /\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i.test(imagesLink)) {
    return [imagesLink];
  }
  return [];
}

export const FUTUREFAIR_GALLERIES = Object.fromEntries(
  FUTUREFAIR_2026_DATA.map(entry => [
    entry.booth,
    {
      venue_name: entry.galleryName,
      location: entry.galleryLocation || undefined,
      url: entry.galleryWebsite || undefined,
      images: toImageList(entry.imagesLink),
      artists: splitArtists(entry.exhibitingArtists),
      medium: undefined,
    },
  ])
);

const FUTUREFAIR_GALLERIES_BY_NORMALIZED_CODE = Object.fromEntries(
    FUTUREFAIR_2026_DATA.map(entry => [
      normalizeBoothKey(entry.booth),
      {
        venue_name: entry.galleryName,
        location: entry.galleryLocation || undefined,
        url: entry.galleryWebsite || undefined,
        images: toImageList(entry.imagesLink),
        artists: splitArtists(entry.exhibitingArtists),
        medium: undefined,
      },
    ])
  );

export const FUTUREFAIR_BOOTHS = [
  { id: 'BA 1', code: 'BA 1', x: 10.7, y: 77, width: 3.2, height: 3.6, artworks: [] },
  { id: 'SP 1', code: 'SP 1', x: 86.1, y: 68.5, width: 3.7, height: 11.8, artworks: [] },
  { id: 'SP 2', code: 'SP 2', x: 75.2, y: 54.3, width: 3.0, height: 3.8, artworks: [] },
  { id: 'SP 3', code: 'SP 3', x: 64.4, y: 70.2, width: 2.1, height: 6.5, artworks: [] },
  { id: 'E1', code: 'E1', x: 82, y: 61, width: 2.4, height: 7.6, artworks: [] },
  { id: 'E2', code: 'E2', x: 86.1, y: 62.3, width: 3.7, height: 6.2, artworks: [] },
  { id: 'E3', code: 'E3', x: 82, y: 49.8, width: 2.4, height: 7.3, artworks: [] },
  { id: 'E4', code: 'E4', x: 86.1, y: 54, width: 3.7, height: 6.2, artworks: [] },
  { id: 'E5', code: 'E5', x: 82, y: 45.7, width: 2.4, height: 4.1, artworks: [] },
  { id: 'E6', code: 'E6', x: 86.1, y: 47.9, width: 3.7, height: 6.2, artworks: [] },
  { id: 'E7', code: 'E7', x: 78.6, y: 40.7, width: 7.2, height: 3.6, artworks: [] },
  { id: 'E8', code: 'E8', x: 85.8, y: 40.7, width: 3.5, height: 3.6, artworks: [] },
  { id: 'E9', code: 'E9', x: 75.3, y: 47.9, width: 2.9, height: 6.5, artworks: [] },
  { id: 'E10', code: 'E10', x: 72.4, y: 54.2, width: 2.7, height: 3.8, artworks: [] },
  { id: 'E11', code: 'E11', x: 72.4, y: 48.5, width: 2.7, height: 5.8, artworks: [] },
  { id: 'F1', code: 'F1', x: 14, y: 77, width: 3.4, height: 3.6, artworks: [] },
  { id: 'F2 A', code: 'F2 A', x: 14.8, y: 66.8, width: 2.5, height: 4.7, artworks: [] },
  { id: 'F4', code: 'F4', x: 17.5, y: 66.8, width: 4.1, height: 4.7, artworks: [] },
  { id: 'F3', code: 'F3', x: 17.4, y: 77, width: 3.3, height: 3.6, artworks: [] },
  { id: 'F5', code: 'F5', x: 20.8, y: 77, width: 5.3, height: 3.6, artworks: [] },
  { id: 'F6', code: 'F6', x: 21.6, y: 66.8, width: 2.7, height: 4.7, artworks: [] },
  { id: 'F7', code: 'F7', x: 26.1, y: 77, width: 3.5, height: 3.6, artworks: [] },
  { id: 'F8', code: 'F8', x: 24.3, y: 66.8, width: 2.6, height: 4.7, artworks: [] },
  { id: 'F9', code: 'F9', x: 29.7, y: 77, width: 2.1, height: 3.6, artworks: [] },
  { id: 'F10', code: 'F10', x: 26.9, y: 66.8, width: 2.9, height: 4.7, artworks: [] },
  { id: 'F12', code: 'F12', x: 29.7, y: 66.8, width: 2.2, height: 4.7, artworks: [] },
  { id: 'F13', code: 'F13', x: 38, y: 76.6, width: 5.6, height: 3.8, artworks: [] },
  { id: 'F14', code: 'F14', x: 38, y: 65.7, width: 3, height: 5.8, artworks: [] },
  { id: 'F15', code: 'F15', x: 43.6, y: 76.6, width: 3.6, height: 3.8, artworks: [] },
  { id: 'F16', code: 'F16', x: 41.1, y: 67.9, width: 3.5, height: 3.3, artworks: [] },
  { id: 'F17', code: 'F17', x: 44.6, y: 67.9, width: 2.9, height: 3.3, artworks: [] },
  { id: 'U1', code: 'U1', x: 48.2, y: 25.6, width: 1.6, height: 12.4, artworks: [] },
  { id: 'U2', code: 'U2', x: 48.2, y: 37.6, width: 1.6, height: 9.5, artworks: [] },
  { id: 'U8', code: 'U8', x: 47.2, y: 76.6, width: 2.7, height: 3.8, artworks: [] },
  { id: 'U3', code: 'U3', x: 50, y: 51, width: 2.7, height: 4.4, artworks: [] },
  { id: 'U4', code: 'U4', x: 48.1, y: 53.3, width: 2.1, height: 9.8, artworks: [] },
  { id: 'U5', code: 'U5', x: 50.6, y: 59, width: 2.7, height: 3.6, artworks: [] },
  { id: 'U6', code: 'U6', x: 48.1, y: 63, width: 2.1, height: 10.6, artworks: [] },
  { id: 'R1', code: 'R1', x: 73.2, y: 33.7, width: 3.0, height: 5.8, artworks: [] },
  { id: 'R2', code: 'R2', x: 72.5, y: 25.3, width: 3.8, height: 5.1, artworks: [] },
  { id: 'R3', code: 'R3', x: 71.3, y: 37.4, width: 2.1, height: 3.5, artworks: [] },
  { id: 'R4', code: 'R4', x: 69.1, y: 25.3, width: 3.4, height: 5.1, artworks: [] },
  { id: 'R5', code: 'R5', x: 68.2, y: 37.5, width: 3.1, height: 5.7, artworks: [] },
  { id: 'R6', code: 'R6', x: 65.7, y: 25.3, width: 3.4, height: 5.7, artworks: [] },
  { id: 'R7', code: 'R7', x: 65.6, y: 37.6, width: 2.6, height: 5.7, artworks: [] },
  { id: 'R8', code: 'R8', x: 60.7, y: 24.2, width: 5.0, height: 7.6, artworks: [] },
  { id: 'R9', code: 'R9', x: 63, y: 37.9, width: 2.6, height: 5.1, artworks: [] },
  { id: 'R10', code: 'R10', x: 57.9, y: 25.5, width: 2.8, height: 5.8, artworks: [] },
  { id: 'R11', code: 'R11', x: 60.4, y: 34.8, width: 2.6, height: 3.6, artworks: [] },
  { id: 'R12', code: 'R12', x: 54.9, y: 25.5, width: 3.0, height: 4.4, artworks: [] },
  { id: 'R13', code: 'R13', x: 56.8, y: 33.9, width: 3.4, height: 5.1, artworks: [] },
  { id: 'R14 A', code: 'R14 A', x: 52.5, y: 25.5, width: 1.2, height: 4.4, artworks: [] },
  { id: 'R14 B', code: 'R14 B', x: 53.7, y: 25.5, width: 1.2, height: 4.4, artworks: [] },
  { id: 'R16', code: 'R16', x: 49.8, y: 25.5, width: 2.7, height: 4.4, artworks: [] },
  { id: 'R15', code: 'R15', x: 52.9, y: 32.8, width: 3.0, height: 4.0, artworks: [] },
  { id: 'T1', code: 'T1', x: 51.9, y: 47.4, width: 2.7, height: 4.0, artworks: [] },
  { id: 'T3', code: 'T3', x: 54.5, y: 54.3, width: 3.4, height: 3.6, artworks: [] },
  { id: 'T4 A', code: 'T4 A', x: 55.9, y: 47.0, width: 3.8, height: 3.6, artworks: [] },
  { id: 'T5', code: 'T5', x: 58.3, y: 60, width: 3.1, height: 5.1, artworks: [] },
  { id: 'T6', code: 'T6', x: 59.7, y: 50.7, width: 3.6, height: 4.4, artworks: [] },
  { id: 'T2', code: 'T2', x: 54.0, y: 40.5, width: 3.4, height: 4.4, artworks: [] },
  { id: 'T7', code: 'T7', x: 60.9, y: 67.5, width: 3.2, height: 4.4, artworks: [] },
  { id: 'T8', code: 'T8', x: 63.6, y: 55.5, width: 1.7, height: 9, artworks: [] },
  { id: 'T9', code: 'T9', x: 63.6, y: 47.8, width: 1.7, height: 7.7, artworks: [] },
  { id: 'T10', code: 'T10', x: 59.6, y: 41.2, width: 3.0, height: 4.5, artworks: [] },
  { id: 'U9', code: 'U9', x: 52.5, y: 75.4, width: 4, height: 4.4, artworks: [] },
  { id: 'U10', code: 'U10', x: 53.8, y: 62, width: 3.2, height: 4.4, artworks: [] },
  { id: 'U11', code: 'U11', x: 56.5, y: 75.4, width: 4.4, height: 4.4, artworks: [] },
  { id: 'U12', code: 'U12', x: 57.0, y: 68.1, width: 3.0, height: 4.7, artworks: [] },
  { id: 'U13', code: 'U13', x: 60.9, y: 74, width: 2.5, height: 5.8, artworks: [] },
  { id: 'U15', code: 'U15', x: 54.0, y: 65.2, width: 3.1, height: 2.2, artworks: [] },
];

const FUTUREFAIR_LAYOUT_BY_NORMALIZED_CODE = Object.fromEntries(
  FUTUREFAIR_BOOTHS.map(booth => [normalizeBoothKey(booth.code), booth])
);

export const FUTUREFAIR_2026_DATA_WITH_LAYOUT = FUTUREFAIR_2026_DATA.map(entry => {
    const codeNormalized = normalizeBoothKey(entry.booth);
    const mapBooth = FUTUREFAIR_LAYOUT_BY_NORMALIZED_CODE[codeNormalized];

    return {
      ...entry,
      codeNormalized,
      mapBoothId: mapBooth?.id,
      mapBoothName: mapBooth?.name,
      mapCode: mapBooth?.code,
      x: mapBooth?.x,
      y: mapBooth?.y,
      width: mapBooth?.width,
      height: mapBooth?.height,
      hasMapLayout: Boolean(mapBooth),
    };
  });

export const FUTUREFAIR_2026_WITHOUT_LAYOUT =
  FUTUREFAIR_2026_DATA_WITH_LAYOUT.filter(entry => !entry.hasMapLayout);

export function getGalleryByCode(code) {
  return (
    FUTUREFAIR_GALLERIES[code] ||
    FUTUREFAIR_GALLERIES_BY_NORMALIZED_CODE[normalizeBoothKey(code)] ||
    null
  );
}

export function enrichBoothWithGalleryData(booth) {
  const galleryData = getGalleryByCode(booth.code);
  if (!galleryData) return booth;

  return {
    ...booth,
    name: galleryData.venue_name,
    location: galleryData.location,
    url: galleryData.url,
    instagram: galleryData.instagram,
    artists: galleryData.artists,
    medium: galleryData.medium,
    artworks: galleryData.images.map((image, index) => ({
      title: `Artwork ${index + 1}`,
      artist: galleryData.artists[0] || 'Unknown Artist',
      image,
    })),
  };
}

export const ENRICHED_FUTUREFAIR_BOOTHS = FUTUREFAIR_2026_DATA_WITH_LAYOUT.filter(
  entry => entry.hasMapLayout
).map(entry => {
    const mapBooth = FUTUREFAIR_LAYOUT_BY_NORMALIZED_CODE[entry.codeNormalized];

    const booth = {
      id: mapBooth.id,
      code: mapBooth.code,
      // Prefer ground-truth naming whenever available.
      name: entry.galleryName,
      x: mapBooth.x,
      y: mapBooth.y,
      width: mapBooth.width,
      height: mapBooth.height,
      artworks: [],
    };

    return enrichBoothWithGalleryData(booth);
  });

/**
 * Extracts the booth code embedded in a DB show title.
 * Handles formats like "SEIZAN (Booth U10)" → "U10"
 */
export function extractBoothCodeFromTitle(title) {
  const match = title.match(/\(Booth\s+([^)]+)\)/i);
  return match ? match[1].trim() : null;
}

/**
 * Merges live DB show data into the pre-built enriched booths list.
 * For each booth whose code matches a DB show title (e.g. "(Booth U10)"),
 * the show's image_urls replace the placeholder artwork images.
 * Falls back to the hardcoded FUTUREFAIR_2026_DATA images when no DB match is found.
 */
export function enrichBoothsWithDbShows(booths, dbShows) {
  // Build map: normalized booth code → DB show
  const showByCode = new Map();
  for (const show of dbShows) {
    const code = extractBoothCodeFromTitle(show.show_title);
    if (code) {
      showByCode.set(normalizeBoothKey(code), show);
    }
  }

  return booths.map(booth => {
    const dbShow = showByCode.get(normalizeBoothKey(booth.code));
    if (!dbShow) return booth;

    return {
      ...booth,
      ...(dbShow.short_description ? { short_description: dbShow.short_description } : {}),
      ...(!dbShow.image_urls?.length
        ? {}
        : {
            artworks: dbShow.image_urls.map((image, index) => ({
              title: `Artwork ${index + 1}`,
              artist: booth.artists?.[0] || 'Unknown Artist',
              image,
            })),
          }),
    };
  });
}
